<div class="card" [ngStyle]="{'height': scrollHeight, 'overflow-y': 'auto'}">
  <p-table class="custom-table-container" [scrollable]="true" [autoLayout]="true" rowHover="true" showGridlines="true"
    [value]="dataReport.data" stripedRows>
    <ng-template pTemplate="caption">
      <div class="caption-container" #headerContainer>
        <div class="card p-2" *ngIf="dataReport.captionDescription.length || dataReport.captionFilters.length">
          <div class="caption caption-description ">
            <span *ngFor="let description of dataReport.captionDescription">
              {{ description }}
            </span>
          </div>
          <div class="caption caption-filters">
            <span *ngFor="let filter of dataReport.captionFilters">
              {{ filter }}
            </span>
          </div>
        </div>
        <!-- HOJA DE VIDA -->
        <div class="logbook-box" *ngIf="dataReport.equipmentLogbookInfo && dataReport.equipmentLogbookInfo.length > 0">
          <table class="logbook-table" *ngFor="let info of dataReport.equipmentLogbookInfo">
            <tbody>
              <tr>
                <td class="lb-label">Artículo:</td>
                <td class="lb-value" colspan="5">{{ info.articleName }}</td>
                <td class="lb-label">Código:</td>
                <td class="lb-value">{{ info.articleCode }}</td>
              </tr>
              <tr>
                <td class="lb-label">Marca:</td>
                <td class="lb-value" colspan="2">{{ info.tradeMark }}</td>
                <td class="lb-label">Referencia:</td>
                <td class="lb-value" colspan="2">{{ info.reference }}</td>
                <td class="lb-label">Serie:</td>
                <td class="lb-value">{{ info.serie }}</td>
              </tr>
              <tr>
                <td class="lb-label">Nombre Ccial:</td>
                <td class="lb-value" colspan="5">{{ info.commercialName }}</td>
                <td class="lb-label">Tipo Equipo:</td>
                <td class="lb-value">{{ info.equipmentType }}</td>
              </tr>
              <tr>
                <td class="lb-label">Proveedor:</td>
                <td class="lb-value" [attr.colspan]="isValued ? 3 : 5">{{ info.providerName }}</td>
                <td *ngIf="isValued" class="lb-label">Vr. Compra:</td>
                <td *ngIf="isValued" class="lb-value">{{ info.purchaseValue }}</td>
                <td class="lb-label">Nro.Factura:</td>
                <td class="lb-value">{{ info.invoiceNumber }}</td>
              </tr>
              <tr>
                <td class="lb-label">Fec.Compra:</td>
                <td class="lb-value">{{ info.purchaseDate }}</td>
                <td class="lb-label">Garantía Ini:</td>
                <td class="lb-value">{{ info.warrantyInitialDate }}</td>
                <td class="lb-label">Garantía Fin:</td>
                <td class="lb-value">{{ info.warrantyFinalDate }}</td>
                <td class="lb-label">Capacidad:</td>
                <td class="lb-value">{{ info.capacity }}</td>
              </tr>
              <tr>
                <td class="lb-label">Año Fabricación:</td>
                <td class="lb-value">{{ info.yearManufacture }}</td>
                <td class="lb-label">Tipo Motor:</td>
                <td class="lb-value">{{ info.engineType }}</td>
                <td class="lb-label">Cód. Motor:</td>
                <td class="lb-value">{{ info.engineCode }}</td>
                <td class="lb-label">Ref. Motor:</td>
                <td class="lb-value">{{ info.referenceEngine }}</td>
              </tr>
              <tr>
                <td class="lb-label">Marca Motor:</td>
                <td class="lb-value">{{ info.trademarkEngine }}</td>
                <td class="lb-label">Serie Motor:</td>
                <td class="lb-value">{{ info.serieEngine }}</td>
                <td class="lb-label">Uni. Medida:</td>
                <td class="lb-value">{{ info.unitName }}</td>
                <td class="lb-label">Frecuencia:</td>
                <td class="lb-value">{{ info.maintenanceFrequency }}</td>
              </tr>
              <tr>
                <td class="lb-label">Voltaje:</td>
                <td class="lb-value" colspan="2">{{ info.voltage }}</td>
                <td class="lb-label">Potencia:</td>
                <td class="lb-value" colspan="2">{{ info.power }}</td>
                <td class="lb-label">Amperaje:</td>
                <td class="lb-value">{{ info.amperage }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ORDENES DE MANTENIMIENTO -->
        <div *ngIf="dataReport.data && dataReport.data.length > 0">
          <div class="section-title">REPARACIONES:</div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let header of dataReport.headers" class="column-header">
          <div class="d-flex justify-content-center" [class.separator]="header.name === ''">
            {{ header.name }}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: item, depth: 0 }"></ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td *ngFor="let header of dataReport.headers" [ngStyle]="{'font-weight': 'bold', 'text-align': 'right'}">
          <ng-container *ngIf="dataReport.totals && isDecimal(dataReport.totals[header.propertyName]); else textValue">
            {{ dataReport.totals[header.propertyName] | number:'1.2-2'}}
          </ng-container>
          <ng-template #textValue>
            {{ dataReport.totals ? dataReport.totals[header.propertyName] : '' }}
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template #recursiveRow let-item let-depth="depth">
    <tr
      [ngStyle]="{ 'font-weight': (item.type !== 'detail') && 'bold','background-color': (item.type !== 'detail') && getBackgroundColor(depth) }">
      <ng-container *ngFor="let header of dataReport.headers; let i = index">
        <td *ngIf="!(item.type !== 'detail' && (item.colspan || 1) > 1 && i > 0 && i < (item.colspan || 1))"
          [attr.colspan]="(item.type !== 'detail' && i === 0) ? (item.colspan || 1) : 1">
          <div [ngStyle]="{
            'padding-left': (header.propertyName === 'name') ? (depth * 5) + 'px' : '5px',
            'text-align': alignColumnText(item[header.propertyName])
          }">
            <ng-container *ngIf="isDecimal(item[header.propertyName]); else textValue">
              {{ item[header.propertyName] | number:'1.2-2'}}
            </ng-container>
            <ng-template #textValue>
              {{ item[header.propertyName] }}
            </ng-template>
          </div>
        </td>
      </ng-container>
    </tr>
    <ng-container *ngIf="item.children">
      <ng-container *ngFor="let child of item.children">
        <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: child, depth: depth + 1 }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>

  <!-- FACTURAS -->
  <div *ngIf="dataReport.invoices && dataReport.invoices.length > 0">
    <div class="section-title">FACTURAS:</div>
    <div class="invoices-wrapper">
      <div *ngFor="let invoiceGroup of dataReport.invoices" class="table-container invoice-container">
        <p-table [value]="invoiceGroup.details" class="custom-table-container" styleClass="p-datatable-sm"
          showGridlines>
          <ng-template pTemplate="header">
            <tr>
              <th>Concepto</th>
              <th>Nombre</th>
              <th>Valor</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="caption">
            <div class="invoice-caption">
              Sucursal: {{ invoiceGroup.branchCode ? invoiceGroup.branchCode + ' - ' : '' }}{{ invoiceGroup.branchName
              }}
            </div>
          </ng-template>
          <ng-template pTemplate="body" let-invoice>
            <tr>
              <td>{{ invoice.conceptCode }}</td>
              <td>{{ invoice.conceptName }}</td>
              <td class="invoice-value">{{ invoice.value }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="2" class="invoice-total-cell">Total Sucursal:</td>
              <td class="invoice-total-cell">{{ invoiceGroup.totalBranch }}</td>
            </tr>
            <tr>
              <td colspan="2" class="invoice-total-cell">Total General:</td>
              <td class="invoice-total-cell">{{ dataReport.totalInvoicesGeneral }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>